import { Link } from "react-router-dom";
import { LENDERS, LENDER_REL, lender, lenderUrl, lendersFor } from "../../config/financing";
import { trackFinancingClick } from "../../lib/analytics";

// The only way a lender link is rendered: exact URL from the config (+ optional loanAmount where the lender accepts one),
// new tab, rel="noopener sponsored", tracked as financing_click, never delayed.
export const LenderLink = ({ lender: id = "acorn", placement, loanAmount, href, className = "", children, testId, ariaLabel }) => {
  const l = lender(id);
  const url = href || lenderUrl(id, loanAmount);
  const label = ariaLabel || (typeof children === "string" ? children : l.buttonLabel);
  return (
    <a
      href={url}
      target="_blank"
      rel={LENDER_REL}
      aria-label={`${label} (opens in a new tab)`}
      className={className}
      onClick={() => trackFinancingClick(id, placement, loanAmount)}
      data-testid={testId || `${id}-link-${placement}`}
      data-placement={placement}
      data-lender={id}
    >
      {children || l.buttonLabel}
    </a>
  );
};

// Kept for inline "[text](acorn url)" rich-text links.
export const AcornLink = (props) => <LenderLink lender="acorn" {...props} />;

export const BTN_PRIMARY = "btn-accent rounded-full px-7 py-3.5 text-center uppercase tracking-wider text-sm font-bold";
export const BTN_OUTLINE_DARK = "border border-white/25 text-white rounded-full px-7 py-3.5 text-center uppercase tracking-wider text-sm font-bold hover:bg-white hover:text-[#111] transition-colors";
export const BTN_OUTLINE_LIGHT = "border-2 border-[#111] text-[#111] rounded-full px-7 py-3.5 text-center uppercase tracking-wider text-sm font-bold hover:bg-[#111] hover:text-white transition-colors";

// One button per lender that covers `amount` (all lenders when no amount), full-width on phones. The first lender is the
// primary button, the rest outlined (`tone` picks the outline colour for the background it sits on). `extra` renders after.
export const LenderButtons = ({ placement, amount, tone = "dark", size = "", className = "", loanAmount, extra = null, testPrefix = "" }) => {
  const list = lendersFor(amount);
  const outline = tone === "dark" ? BTN_OUTLINE_DARK : BTN_OUTLINE_LIGHT;
  return (
    <div className={`flex flex-col sm:flex-row gap-3 ${className}`} data-testid={`${testPrefix || placement}-lender-buttons`}>
      {list.map((l, i) => (
        <LenderLink key={l.id} lender={l.id} placement={placement} loanAmount={l.amountParam ? loanAmount : undefined} className={`${i === 0 ? BTN_PRIMARY : outline} ${size} w-full sm:w-auto`} testId={`${testPrefix || placement}-${l.id}`}>{l.buttonLabel}</LenderLink>
      ))}
      {extra}
    </div>
  );
};

// "Financing options" fallback for tight spots.
export const FinancingPageLink = ({ className = "", testId = "financing-page-link", children = "How financing works" }) => (
  <Link to="/financing#lenders" className={className} data-testid={testId}>{children}</Link>
);

export { LENDERS };
